import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type ListingPriceFairness = {
  listing_price: number;
  median_price: number;
  sample_size: number;
  fairness_label: 'good' | 'fair' | 'high' | 'unknown';
  delta_pct: number | null;
};

/**
 * Single shared fetch of get_listing_price_fairness per listing.
 * PriceFairnessBadge and PriceBenchmarkBar both use this key, so React Query
 * dedupes them into one RPC call.
 */
export function useListingPriceFairness(listingId: string | undefined) {
  return useQuery({
    queryKey: ['listing-price-fairness', listingId],
    enabled: !!listingId,
    staleTime: 10 * 60 * 1000,
    queryFn: async (): Promise<ListingPriceFairness | null> => {
      const { data, error } = await supabase.rpc('get_listing_price_fairness', { p_listing_id: listingId! });
      if (error) throw error;
      const rows = (data as ListingPriceFairness[] | null) || [];
      return rows.length ? rows[0] : null;
    },
  });
}
